import React from "react";
import { IPassportBusinessType } from "src/stores/Passport.store";
import { Button } from "src/components";
import {
  ModalManager,
  Modal,
  ModalContent,
  ModalFooter,
} from "src/components/Modal";
import { Text } from "src/components/Text";
import { useTranslation } from "src/hooks/useTranslation";
import styled from "styled-components";

export const ListContainerEl = styled.ul`
  list-style: disc;
  padding-left: 1em;
  font-family: ${(props) => props.theme.text.fontFamily.normal};
  line-height: ${(props) => props.theme.text.lineHeight.normal};
  color: ${(props) => props.theme.colors.text.soft};
`;

export const ListEl = styled.li`
  margin-bottom: ${(p) => p.theme.dimension.spacing.l}px;
  margin-left: ${(p) => p.theme.dimension.spacing.s}px;
  :last-child {
    margin-bottom: -${(p) => p.theme.dimension.spacing.xl}px;
  }
`;

type Props = {
  show: boolean;
  onClose: () => any;
  selectedBusinessType: IPassportBusinessType;
};

export const OwnerInfoModal = ({
  show,
  onClose,
  selectedBusinessType,
}: Props) => {
  const translate = useTranslation() as any;

  const renderContent = () => {
    if (
      !Array.isArray(
        translate(`owner_info.modal.identity.${selectedBusinessType}`)
      )
    ) {
      return null;
    }

    return translate(
      `owner_info.modal.identity.${selectedBusinessType}`
    ).map((content: string, key: number) => (
      <ListEl key={key}>{content}</ListEl>
    ));
  };

  return (
    <ModalManager showModal={show} onClose={onClose}>
      <Modal fitWidth style={{ height: "auto" }}>
        <ModalContent>
          <Text marginBottomL marginTopS fontWeight="demi">
            {translate("owner_info.modal.identity.title")}
          </Text>
          <ListContainerEl>{renderContent()}</ListContainerEl>
        </ModalContent>
        <ModalFooter>
          <Button onClick={onClose}>
            {translate("owner_info.modal.identity.cta_close")}
          </Button>
        </ModalFooter>
      </Modal>
    </ModalManager>
  );
};
